<form (ngSubmit)="onSubmit()">
  @if (success()) {
    <ui-alert variant="success">
      <div class="flex items-center gap-2.5">
        <ng-icon name="lucideCircleCheck" size="18" />
        <span>{{ success() }}</span>
      </div>
    </ui-alert>
  }

  @if (error()) {
    <ui-alert variant="danger">
      <div class="flex items-center gap-2.5">
        <ng-icon name="lucideCircleAlert" size="18" />
        <span>{{ error() }}</span>
      </div>
    </ui-alert>
  }

  @if (mode() !== 'recovery') {
    <ui-form-field
      for="currentPassword"
      [label]="mode() === 'required' ? 'Temporary password' : 'Current password'"
    >
      <input
        uiInput
        type="password"
        id="currentPassword"
        [(ngModel)]="currentPassword"
        name="currentPassword"
        autocomplete="current-password"
        [placeholder]="mode() === 'required' ? 'Enter the password from your welcome email' : 'Enter your current password'"
      />
    </ui-form-field>
  }

  <ui-form-field for="newPassword" label="New password">
    <input
      uiInput
      type="password"
      id="newPassword"
      [(ngModel)]="newPassword"
      name="newPassword"
      autocomplete="new-password"
      placeholder="Enter your new password"
    />
    <p class="mt-1 text-xs text-muted">At least 12 characters with upper and lower case, a digit and a special character.</p>
  </ui-form-field>

  <ui-form-field for="confirmPassword" label="Confirm new password">
    <input
      uiInput
      type="password"
      id="confirmPassword"
      [(ngModel)]="confirmPassword"
      name="confirmPassword"
      autocomplete="new-password"
      placeholder="Confirm your new password"
    />
  </ui-form-field>

  <div class="mt-2 border-t border-border pt-5">
    <button type="submit" uiButton variant="primary" [block]="true" [disabled]="loading()">
      {{ loading() ? 'Saving...' : (mode() === 'voluntary' ? 'Change password' : 'Set new password') }}
    </button>
  </div>
</form>
